export { getScore } from './getScore';

export const PSSA_CLUB_ID = '5da61cbcc97d0b01a7b03242' as const;
